export const TYPE = 'type';
export const PUBLIC = 'public';
export const APP_ID = "app_id";
export const APP_KEY = "app_key";
export const FIELD = "field";
export const RANDOM = "random";
export const DISH_TYPE = "dishType";
export const CUISINE_TYPE = "cuisineType";
export const SEARCH_STRING = "q";
export const BASE_URL = 'https://api.edamam.com/api/recipes/v2';
// export const BASE_URL = 'https://random.com/api/recipes/v2';
export const RECIPE_BY_ID_URL = '/{id}';